export const APP_VERSION = '23.1.23'

const PREFIX = 'aden:v8:'
export const storage = { get(key, fallback=null){try{const value=localStorage.getItem(PREFIX+key);return value?JSON.parse(value):fallback}catch{return fallback}}, set(key,value){try{localStorage.setItem(PREFIX+key,JSON.stringify(value));return true}catch{return false}}, remove(key){localStorage.removeItem(PREFIX+key)} }
export const draftKey=(kind,userId='anonymous')=>`draft:${kind}:${userId}`
export const saveDraft=(key,value)=>storage.set(key,{value,savedAt:new Date().toISOString(),version:1})
export const loadDraft=key=>storage.get(key)
export const clearDraft=key=>storage.remove(key)
export const apiErrorMessage=(error,fallback='Não foi possível concluir esta ação.')=>{const detail=error?.response?.data?.detail;const validation=Array.isArray(detail)?detail.map(item=>item?.msg).filter(Boolean).join(' · '):'';const id=error?.requestId||error?.response?.headers?.['x-request-id'];const reason=typeof detail==='string'?detail:validation||fallback;const next=error?.response?.status===403?'Confirme se seu perfil possui permissão.':error?.response?.status>=500?'Tente novamente em instantes.':'Revise os dados e tente novamente.';return `${reason} ${next}${id?` Código: ${id}`:''}`}
export const completeCacheKey=(resource,{userId='anonymous',organizationId='none',filters={}}={})=>`${APP_VERSION}:${userId}:${organizationId}:${resource}:${JSON.stringify(Object.entries(filters).sort(([a],[b])=>a.localeCompare(b)))}`
export function createQueryCache({ttl=30000,max=100}={}){const entries=new Map();return{async get(key,loader,{force=false}={}){const current=entries.get(key);if(!force&&current?.data&&Date.now()-current.at<ttl)return current.data;if(current?.promise)return current.promise;const promise=loader().then(data=>{entries.set(key,{data,at:Date.now()});return data}).catch(error=>{entries.delete(key);throw error});entries.set(key,{...current,promise});if(entries.size>max)entries.delete(entries.keys().next().value);return promise},peek:key=>entries.get(key)?.data,invalidate:prefix=>[...entries.keys()].forEach(key=>{if(key.includes(prefix))entries.delete(key)}),invalidateAll:()=>entries.clear()}}
export function updateDynamicFavicon(svgContent) {
  try {
    // Remove qualquer link de ícone antigo para forçar o navegador a descartar o cache
    const existingLinks = document.querySelectorAll("link[rel*='icon']")
    existingLinks.forEach(el => el.remove())

    let finalHref = '/favicon.svg'
    let isSvgData = false

    if (svgContent && typeof svgContent === 'string' && svgContent.includes('<svg')) {
      isSvgData = true
      finalHref = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`
    } else {
      // Adiciona cachebuster com timestamp se for arquivo estático
      finalHref = `/favicon.svg?v=${Date.now()}`
    }

    // Cria link rel="icon"
    const linkIcon = document.createElement('link')
    linkIcon.id = 'dynamic-favicon'
    linkIcon.rel = 'icon'
    linkIcon.type = 'image/svg+xml'
    linkIcon.href = finalHref
    document.head.appendChild(linkIcon)

    // Cria link rel="shortcut icon" (para compatibilidade estrita do Chrome/Edge)
    const linkShortcut = document.createElement('link')
    linkShortcut.rel = 'shortcut icon'
    linkShortcut.type = 'image/svg+xml'
    linkShortcut.href = finalHref
    document.head.appendChild(linkShortcut)
  } catch (err) {
    console.error('Erro ao atualizar favicon:', err)
  }
}
export const queryCache=createQueryCache()
